module.exports = __webpack_public_path__ + "img/ic_housing_bureau_support.b670622b.svg";